// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Deal, JacketType } from '@interfaces/deal.interfaces';
import { DealsService } from '@services/deals.service';
import { takeWhile } from 'rxjs/operators';
import { DealershipService } from '../../../services/dealership.service';
@Component({
    selector: 'app-all-deals',
    templateUrl: './all-deals.component.html',
    styleUrls: ['./all-deals.component.scss'],
})
export class AllDealsComponent implements OnInit, OnDestroy, AfterViewInit {
    deals: Deal[] = [];
    dealsLookupForm: FormGroup;
    isFiltered = false;
    selectedDealType = 1;
    public isLoading = false;
    private isComponentAlive = true;

    constructor(
        private readonly dealsService: DealsService,
        private readonly dealershipService: DealershipService
    ) {
        this.dealsService
            .getDealsByType$(JacketType.Deal)
            .pipe(takeWhile(() => this.isComponentAlive))
            .subscribe((deals) => (this.deals = deals.deals));
    }

    ngOnInit(): void {
        this.dealsLookupForm = new FormGroup({
            query: new FormControl(''),
        });

        this.dealsLookupForm.get('query').valueChanges.subscribe(() => this.searchDeals());
    }

    ngAfterViewInit(): void {
        this.dealershipService.dealershipUpdate$.pipe(takeWhile(() => this.isComponentAlive)).subscribe(() => {
            this.dealsService
                .getDealsByType$(JacketType.Deal)
                .pipe(takeWhile(() => this.isComponentAlive))
                .subscribe((deals) => (this.deals = deals.deals));
        });
    }

    clear() {
        this.dealsLookupForm.get('query').setValue('');
    }

    selectDealType(dealType) {
        this.selectedDealType = dealType;
        this.dealsService
            .getDeals$(dealType, undefined, undefined, undefined, JacketType.Deal)
            .pipe(takeWhile(() => this.isComponentAlive))
            .subscribe((deals) => (this.deals = deals.deals));
    }

    searchDeals() {
        const query: string = this.dealsLookupForm.getRawValue().query;
        if (query.length > 1) {
            this.isFiltered = true;
            this.dealsService
                .getDeals$([this.selectedDealType], query, undefined, undefined, JacketType.Deal)
                .pipe(takeWhile(() => this.isComponentAlive))
                .subscribe((deals) => (this.deals = deals.deals));
        } else {
            if (this.isFiltered) {
                this.dealsService
                    .getDeals$([this.selectedDealType], '', undefined, undefined, JacketType.Deal)
                    .pipe(takeWhile(() => this.isComponentAlive))
                    .subscribe((deals) => (this.deals = deals.deals));
            }
            this.isFiltered = false;
        }
    }

    ngOnDestroy(): void {
        this.isComponentAlive = false;
    }
}
